"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.create.title': 'Utwórz Nowy Zawód',
};
